import { fetchWithTimeout } from "@utils/fetchWithTimeout";
import type React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";

interface IconMapperProps {
	iconRef: string;
	color?: string;
	sizeMobile?: number;
	sizeLaptop?: number;
	sizeDesktop?: number;
	[key: string]: unknown;
}

const IconMapper: React.FC<IconMapperProps> = ({
	iconRef,
	color = "black",
	// sizeMobile = 40,
	// sizeLaptop = 50,
	// sizeDesktop = 60,
	...props
}) => {
	const [iconContent, setIconContent] = useState<string | null>(null);

	useEffect(() => {
		fetchWithTimeout(`/icons/${iconRef.toLowerCase()}.svg`)
			.then((response) => {
				return response.text();
			})
			.then((text) => setIconContent(text))
			.catch((error) => console.warn(error.message));
	}, [iconRef]);

	if (!iconContent) return null;

	const processedIconContent = iconContent.replace(
		/(<(?:path|circle|rect|polygon|ellipse|line|polyline)[^>]*?)(fill=["'][^"']*["'])?/g,
		`$1 fill="${color}"`,
	);

	return (
		<div
			dangerouslySetInnerHTML={{ __html: processedIconContent }}
			{...props}
		/>
	);
};

const StyledIconMapper = styled(IconMapper)<IconMapperProps>`
  display: flex;
  align-items: center;

  svg {
    width: ${(props) => props.sizeMobile || 100}px;
    height: ${(props) => props.sizeMobile || 100}px;
    cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  }

  @media screen and (min-width: 768px) {
    svg {
      width: ${(props) => props.sizeLaptop || 200}px;
      height: ${(props) => props.sizeLaptop || 200}px;
    }
  }

  @media screen and (min-width: 1024px) {
    svg {
      width: ${(props) => props.sizeDesktop || 300}px;
      height: ${(props) => props.sizeDesktop || 300}px;
    }
  }
`;

export default StyledIconMapper;
